import { apiGet, apiPatch } from '../../../shared/api-client/index.js';

export interface WorkspaceSettingsResponse {
  workspaceId: string;
  featureFlags: Record<string, boolean>;
  agentConfig?: Record<string, unknown> | null;
}

export interface UpdateWorkspaceSettingsInput {
  featureFlags: Record<string, boolean>;
}

export interface AgentConfigResponse {
  systemPromptAppend?: string;
  systemPromptOverride?: string;
  skills?: Array<{
    name: string;
    description?: string;
    instructions: string;
    triggers?: string[];
    toolAllowlist?: string[];
  }>;
  mcpServers?: Array<{
    name: string;
    url: string;
    transport?: 'sse' | 'http';
    headersRef?: string;
  }>;
  model?: string;
  temperature?: number;
  enabledTools?: string[];
}

export function getWorkspaceSettingsQueryKey(workspaceId: string): readonly [string, string] {
  return ['workspace-settings', workspaceId] as const;
}

export async function getWorkspaceSettings(): Promise<WorkspaceSettingsResponse> {
  return apiGet<WorkspaceSettingsResponse>('/settings/feature-flags');
}

export async function patchWorkspaceSettings(
  input: UpdateWorkspaceSettingsInput,
): Promise<WorkspaceSettingsResponse> {
  return apiPatch<WorkspaceSettingsResponse, UpdateWorkspaceSettingsInput>(
    '/settings/feature-flags',
    input,
  );
}

export function getAgentConfigQueryKey(workspaceId: string): readonly [string, string] {
  return ['agent-config', workspaceId] as const;
}

export async function getAgentConfig(): Promise<AgentConfigResponse> {
  return apiGet<AgentConfigResponse>('/settings/agent-config');
}

export async function patchAgentConfig(input: AgentConfigResponse): Promise<AgentConfigResponse> {
  return apiPatch<AgentConfigResponse, AgentConfigResponse>('/settings/agent-config', input);
}
